import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-ok",
  "use": "svgIcon-ok-usage",
  "viewBox": "-16.707 537.695 2385.678 2300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-16.707 537.695 2385.678 2300\" id=\"svgIcon-ok\"><path d=\"m2138 841c-40-40-94-40-134 0l-1096 1096-561-575c-40-40-94-40-134 0l-200 200c-40 40-40 94 0 134l829 842c40 40 94 40 134 0l1363-1363c40-40 40-94 0-134l-200-200\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol